/**
 * ============================================================================
 * СЕРВИС СЕРТИФИКАТОВ
 * ============================================================================
 * Методы для работы с сертификатами
 * ============================================================================
 */

import api from './api'

export const certificatesService = {
	/**
	 * Получить все шаблоны сертификатов курса
	 */
	async getByCourseId(courseId) {
		const response = await api.get(`/courses/${courseId}/certificates`)
		return response.data
	},

	/**
	 * Получить шаблон сертификата по ID
	 */
	async getById(id) {
		const response = await api.get(`/certificates/${id}`)
		return response.data
	},

	/**
	 * Создать новый шаблон сертификата
	 */
	async create(courseId, certificateData) {
		const response = await api.post(
			`/courses/${courseId}/certificates`,
			certificateData
		)
		return response.data
	},

	/**
	 * Обновить шаблон сертификата
	 */
	async update(id, certificateData) {
		const response = await api.put(`/certificates/${id}`, certificateData)
		return response.data
	},

	/**
	 * Удалить шаблон сертификата
	 */
	async delete(id) {
		const response = await api.delete(`/certificates/${id}`)
		return response.data
	},

	/**
	 * Получить активный глобальный шаблон сертификата
	 */
	async getGlobalTemplate() {
		const response = await api.get('/certificates/global-template')
		return response.data
	},

	/**
	 * Получить список course_id с шаблонами сертификатов
	 */
	async getCoursesWithTemplates() {
		const response = await api.get('/certificates/courses-with-templates')
		return response.data
	},

	/**
	 * Получить журнал выдач активного глобального шаблона сертификата
	 */
	async getGlobalIssuedLog(limit = 200) {
		const response = await api.get('/certificates/global-template/issued-log', {
			params: { limit },
		})
		return response.data
	},

	/**
	 * Создать или обновить активный глобальный шаблон сертификата
	 */
	async createOrUpdateGlobalTemplate(certificateData) {
		const response = await api.put('/certificates/global-template', certificateData)
		return response.data
	},

	/**
	 * Копировать шаблон курса в глобальный шаблон
	 */
	async cloneGlobalTemplateFromCourse(courseId, templateId = null) {
		const payload = { courseId }
		if (templateId != null) {
			payload.templateId = templateId
		}
		const response = await api.post('/certificates/global-template/clone-from-course', payload)
		return response.data
	},

	/**
	 * Активировать шаблон
	 */
	async activate(id) {
		const response = await api.post(`/certificates/${id}/activate`)
		return response.data
	},

	/**
	 * Деактивировать шаблон
	 */
	async deactivate(id) {
		const response = await api.post(`/certificates/${id}/deactivate`)
		return response.data
	},

	/**
	 * Выдать сертификат студенту
	 */
	async issue(certificateId, studentId) {
		const response = await api.post(`/certificates/${certificateId}/issue`, {
			studentId,
		})
		return response.data
	},

	/**
	 * Получить список студентов для выдачи сертификатов
	 */
	async getEligibleStudents(courseId) {
		const response = await api.get(
			`/courses/${courseId}/certificates/eligible-students`
		)
		return response.data
	},

	/**
	 * Выдать сертификаты нескольким студентам
	 */
	async issueBulk(courseId, studentIds) {
		const response = await api.post(`/courses/${courseId}/certificates/issue`, {
			studentIds,
		})
		return response.data
	},

	/**
	 * Получить сертификаты студента
	 */
	async getMyCertificates() {
		const response = await api.get('/certificates/my-certificates')
		return response.data
	},

	/**
	 * Мягко удалить выданный сертификат студента
	 */
	async deleteMyCertificate(certificateId, payload = {}) {
		const response = await api.delete(`/certificates/my-certificates/${certificateId}`, {
			data: payload,
		})
		return response.data
	},

	/**
	 * Скачать сертификат
	 */
	async download(certificateId) {
		const response = await api.get(`/certificates/${certificateId}/download`, {
			responseType: 'blob',
		})
		return response
	},

	/**
	 * Загрузить фон для сертификата
	 */
	async uploadBackground(certificateId, file) {
		const formData = new FormData()
		formData.append('background', file)

		const response = await api.post(
			`/certificates/${certificateId}/background`,
			formData,
			{
				headers: {
					'Content-Type': 'multipart/form-data',
				},
			}
		)
		return response.data
	},
}

export default certificatesService
